import { useMemo } from "react";
import ReactSelect from "react-select";
import { customSelectStyles } from "@/components/FederalSelect";
import { groupBy } from "@/lib/utils";

export interface CaseTypeOption {
  label: string | null;
  value: string | null;
  key: string;
}

type Option = { label: string; value: string | null };
type Group = { label: string; options: Option[] };

interface Props {
  options: CaseTypeOption[];
  selected?: string;
  onChange: (value: string) => void;
}

export default function Select({ options, selected, onChange }: Props) {
  const selectedOption = useMemo(() => {
    return options.find((o) => o.value === selected);
  }, [selected, options]);

  const transformedOptions: Group[] = useMemo(() => {
    const group = groupBy(options, (i) => i.key);
    const opts = [];

    for (const k in group) {
      opts.push({
        label: k,
        options: group[k].map((v) => ({
          label: v.label ?? "",
          value: v.value,
        })),
      });
    }

    return opts;
  }, [options]);

  const formatGroupLabel = (data: Group) => {
    return <div>{data.label}</div>;
  };

  const handleChange = (option: Option | null) => {
    onChange(option?.value ?? "");
  };

  return (
    <ReactSelect
      className="select"
      id="case-type"
      //classNamePrefix="brief-point-select"
      options={transformedOptions}
      styles={customSelectStyles}
      value={
        selectedOption?.label
          ? { label: selectedOption?.label, value: selectedOption?.value }
          : null
      }
      onChange={handleChange}
      formatGroupLabel={formatGroupLabel}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#074f6b",
          primary25: "#efefea",
        },
      })}
      //menuIsOpen={true}
      placeholder="Required please select..."
      menuPlacement="auto"
    />
  );
}
